import React from "react";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import ME from "../../assets/me.jpg";
import "./intro.css";

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>4 years</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>30+ Completed Projects</small>
            </article>
          </div>
          <p>
            Hey, I’m Abdulah Džankić, a front-end developer from Bosnia and
            Herzegovina, passionate about creating outstanding web and mobile
            app experiences. My goal isn’t just to build websites – I focus on
            crafting digital solutions that truly make an impact. I specialize
            in developing sleek, responsive websites and powerful mobile apps,
            with a strong background in backend development using Node.js and
            Firebase. I enjoy building full-stack solutions that are scalable
            and impactful. Whether it’s front-end or back-end, I’m here to bring
            your ideas to life and take them to the next level. Feel free to
            reach out if you’re looking to create something truly awesome
            together!
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
